
import React, { useState } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner';
const AddCustomer = () => {

  const [msisdn, setMsisdn] = useState('254');
  const [user_type, setUser_type] = useState('254');
  const [loading, setLoading] = useState(false);

  // Add new Customer
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/customer/register',
        { msisdn, user_type }
      );
      toast.success('Customer added successfully!');
      setMsisdn('254')
      setUser_type('')
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 401) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to add customer.')
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };


  return (
    <div className='mx-auto p-4 flex justify-center'>
      <div className='p-4 bg-white rounded-lg w-full lg:w-full xl:w-1/2'>
        <h3 className='text-xl text-center font-bold text-[#134463]'>Add Customer.</h3>
        <form onSubmit={handleSubmit}>
          <div className='mt-2'>
            <label htmlFor='msisdn'>Phone Number
              <input
                type='text'
                required
                placeholder='Phone Number'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor=""><span>User Type</span>
            <select 
              name="user" id="user"
              className='px-3 py-2 bg-white border border-slate-300 disabled:bg-neutral-100 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
              value={user_type}
              onChange={(e) => {setUser_type(e.target.value)}}
            >
              <option value="">User Type</option>
              <option value="1">Customer</option>
              <option value="2">Agent</option>
              <option value="3">Dealer</option>
            </select>
            </label>
          </div>
          <div className='py-3'>
            <button type='submit' disabled={loading} className='bg-[#134463] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463da]'>{loading ? 'Please wait...' : 'Register Customer'}</button>
          </div>
        </form>
      </div>
    </div>

  )
}

export default AddCustomer
